import { render, staticRenderFns } from "./AllotmentForm.vue?vue&type=template&id=e05a5dc8&scoped=true&"
import script from "./AllotmentForm.vue?vue&type=script&lang=js&"
export * from "./AllotmentForm.vue?vue&type=script&lang=js&"
import style0 from "./AllotmentForm.vue?vue&type=style&index=0&id=e05a5dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05a5dc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCheckbox,VCol,VDialog,VIcon,VSimpleTable,VTextField})
